<div id="donutChartContainer" [ngStyle]="{'display': isdata ? 'block' : 'none', 'visibility': isdata ? 'visible' : 'hidden'}" 
></div>
<!-- <div id="custom-tooltip"></div> -->
<div class="empty_list z-depth-2" [ngStyle]="{'display': !isdata ? 'block' : 'none', 'visibility': !isdata ? 'visible' : 'hidden'}">
    <img src="assets/images/empty_list.png" alt="empty list image" />
  </div>